import { render, staticRenderFns } from "./localeList.vue?vue&type=template&id=5ad8b6a4&"
import script from "./localeList.vue?vue&type=script&lang=js&"
export * from "./localeList.vue?vue&type=script&lang=js&"
import style0 from "./localeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports